import qadisha from "../../assets/Activities/qadishabanner.avif";
import qadishatrans from "../../assets/Activities/qadisha_bottom_banner.avif";
import qadisha2 from "../../assets/Activities/qadisha-poster.jpg";
import img1 from "../../assets/ligori.jpg";
import img2 from "../../assets/ligori.jpg";
import img3 from "../../assets/ligori.jpg";
import img4 from "../../assets/ligori.jpg";
import president1 from "../../assets/Activities/president-cover.jpg";
import president2 from "../../assets/Activities/president-letter.jpg";
import photo1 from "../../assets/activity1.avif";
import photo2 from "../../assets/activity2.avif";
import photo3 from "../../assets/activity3.avif";
import photo4 from "../../assets/activity4.avif";
import Galleryimg1 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-61.jpg";
import Galleryimg2 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-62.jpg";
import Galleryimg3 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-63.jpg";
import Galleryimg4 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-64.jpg";
import Galleryimg5 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-0.jpg";
// import Galleryimg6 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-1.jpg"
import Galleryimg7 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-2.jpg";
import Galleryimg8 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-3.jpg";
import Galleryimg15 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-4.jpg";
import Galleryimg9 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-6.jpg";
import Galleryimg10 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-7.jpg";
import Galleryimg11 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-8.jpg";
import Galleryimg12 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-9.jpg";
import Galleryimg13 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-10.jpg";
import Galleryimg14 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-11.jpg";
import Galleryimg16 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-12.jpg";
import Galleryimg17 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-13.jpg";
import Galleryimg18 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-14.jpg";
import Galleryimg19 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-15.jpg";
import Galleryimg20 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-16.jpg";
import Galleryimg21 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-17.jpg";
import Galleryimg22 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-18.jpg";
import Galleryimg23 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-19.jpg";
// import Galleryimg24 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-20.jpg";
import Galleryimg25 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-21.jpg";
import Galleryimg26 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-22.jpg";
import Galleryimg27 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-23.jpg";
import Galleryimg28 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-24.jpg";
import Galleryimg29 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-25.jpg";
import Galleryimg30 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-26.jpg";
import Galleryimg31 from "../../assets/Gallery/Jouzourouna2014-StJosephCelebration-27.jpg";
const activityData = [
  {
    id: 1,
    title: "Celebrations of Our Lady of Qadisha",
    activityimg: photo1,
    date: "30 July 2016",
    description:
      "That lady standing high on the shoulder of the Valley of Qadisha fragranced with the scent of incense and the prayers of the monks and saints, we aspire in July of every year, the month of harvest, and carry our worries and hope, our pain and joy, to gather with Jouzourana under the shadows of the Lady of Qadisha, and the blessings of the God of Life at the entrances of Bsharri.This year’s celebration comes adorned with the presence of his prominence Bishop Maroun Ammar, the Maronite patriarchal deputy for Besharri, who will preside over the holy mass at 6 PM, along with an assembly of a number of priests and pastors, as well as invitees from all over Lebanon.  The celebration will conclude with a rural dinner with authentic Becharian flavors; with all invited to this gathering of joy.<p class='activity-spec-text'>The Lady of the Valley is waiting for you.</p>",
    img: qadisha2,
    banner: qadisha,
    bottombanner: qadishatrans,
    gallery: [],
  },
  {
    id: 2,
    title: "Religious programs / Saint Joseph",
    activityimg: photo2,
    description:
      "We’ll get introduced to the protector of the redeemer and the holy child, the teacher of love, the guardian of the secret of God, and the man of tough decisions, Saint Joseph the pure; in a special evening with the president of Jouzorona, Father Elie Sader, and the founder of the organization Mr. Nehme Taouk.",
    banner: qadisha,
    gallery: [],
    video: "https://www.youtube.com/watch?v=355mwe88jZM",
  },
  {
    id: 3,
    title: "Consecration of all branches of Soft Solutions to Saint Joseph",
    activityimg: photo3,
    description:
      "On the feast of Saint Joseph on March 19, 2014, Jouzorona consecrated Soft Solutions and all its branches to this saint who is the staple of purity and reference of holiness.  Our father his eminence the Patriarch Cardinal Mar Nasrallah Boutros Sfeir sanctified the celebration and uncovered the curtain off the statue of Saint Joseph.  Bishop of the Maronite Catholic Eparchy of Joubbé Maroun Ammar, celebrated the holy sacrament, and was attended by Bishop Chukralla Nabil Hajj along with a congregation of priests, clerics and the faithful.<br/><p>Bishop Ammar enumerated the virtues of our remarkable Saint, the one who nurtured and raised Jesus Christ, and the guardian of the holy family; and he praised the dedication of the company’s leadership to the Christian issues and deep faith in spreading the word of God through publishing the book on Saint Joseph and disseminating the teachings of the church.</p>",
    banner: qadisha,
    gallery: [
      Galleryimg1,
      Galleryimg2,
      Galleryimg3,
      Galleryimg4,
      Galleryimg5,
      Galleryimg7,
      Galleryimg8,
      Galleryimg9,
      Galleryimg10,
      Galleryimg11,
      Galleryimg12,
      Galleryimg13,
      Galleryimg14,
      Galleryimg15,
      Galleryimg16,
      Galleryimg17,
      Galleryimg18,
      Galleryimg19,
      Galleryimg19,
      Galleryimg20,
      Galleryimg21,
      Galleryimg22,
      Galleryimg23,
      Galleryimg25,
      Galleryimg26,
      Galleryimg27,
      Galleryimg28,
      Galleryimg29,
      Galleryimg30,
      Galleryimg31,
    ],
  },
  {
    id: 4,
    title:
      "Thank you letter to Jouzourouna from the President of the Republic of Lebanon General Michel Sleiman",
    activityimg: photo4,
    description:
      "The President of the Republic of Lebanon General Michel Sleiman and his wife the first lady Ms. Wafaa Sleiman sent a Thank you letter to the president of Jouzorona for their gift of that consisted of a set of valuable spiritual books, and they wished him and the organization well in their humanitarian endeavor.",
    banner: qadisha,
    gallery: [president1, president2],
  },
];
export default activityData;
